import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["menu", "toggle"];

  connect() {
    console.log("Navbar controller connected");
  }

  toggleMenu(event) {
    // Prevent event from bubbling up
    event.stopPropagation();

    this.menuTarget.classList.toggle("active");
    this.toggleTarget.textContent = this.menuTarget.classList.contains("active") ? "✕" : "☰";
  }

  handleOutsideClick(event) {
    // If menu is open and click is outside the menu and not on the toggle
    if (
      this.menuTarget.classList.contains("active") &&
      !this.menuTarget.contains(event.target) &&
      !this.toggleTarget.contains(event.target)
    ) {
      this.menuTarget.classList.remove("active");
      this.toggleTarget.textContent = "☰";
    }
  }
}